/*
 * 获取url的参数内容
 */
export function getUrlQuery(a, url) {
  url = url || window.location.search
  const r = new RegExp('(^|&)' + a + '=([^&]*)(&|$)', 'i')
  const v = url.substr(url.indexOf('?') + 1).match(r)
  return v != null ? v[2] : ''
}
/*
 * 获取系统环境 1:青石app，2:微信,3:qq,4:pc,5其他
 */
export function getFromType() {
  const ua = navigator.userAgent.toLowerCase()
  if (/bluestone/i.test(ua)) {
    return 1
  } else if (ua.match(/MicroMessenger/i) === 'micromessenger') {
    return 2
  } else if (ua.indexOf('qq/') !== -1) {
    return 3
  } else if (!(/iphone/i.test(ua) || /ipad/i.test(ua) || /ipod/i.test(ua)) && !/android/i.test(ua)) {
    return 4
  } else {
    return 5
  }
}




// WEBPACK FOOTER //
// ./src/utils/common.js